import {createSlice} from '@reduxjs/toolkit'
import {DOCUMENT_FETCH_URL, ROUTE_PATH} from "../../app/constants"

const supportingDocuments = () => ({
    cacheData : [],
    header : "Supporting documents",
    text : [""],
    headerRenewal : "Supporting documents",
    textRenewal : ["The following documents were previously provided to Business Licensing used with your clients. Review these"],
    navigation : {
        next : ROUTE_PATH.SURETY_BOND,
        nextRenewal : ROUTE_PATH.APPLICATION_RENEWAL_REVIEW //ROUTE_PATH.SURETY_BOND,// ROUTE_PATH.CONFIRM_BEFORE_PAYMENT //ROUTE_PATH.COLLECTORS_REVIEW - collector screen is removed
    }
})

const supportingDocumentsSlice = createSlice({
    name : "supportingDocuments",
    initialState: supportingDocuments(),
    reducers : {
        setApplicationCache(state, action) { 
            const {payload} = action

            if(state.cacheData 
                && state.cacheData.findIndex(d => d.key === payload.documentGuid) === -1) {
                state.cacheData.push({
                    key : payload.documentGuid,
                    data : payload.data
                })
            }
        }
    }
})

export const {
    setApplicationCache
} = supportingDocumentsSlice.actions

export const fetchDocumentData = (documentGuid) => async (dispatch, getState) => {

    if(documentGuid) {
        const {supportingDocuments} = getState().components

        if(supportingDocuments 
            && supportingDocuments.cacheData
            && supportingDocuments.cacheData.length > 0) 
        {
            const found =  supportingDocuments.cacheData.find(d => d.key === documentGuid)
            if(found && found.data) { 
                return Promise.resolve(found.data)
            }
        }

        return fetch(DOCUMENT_FETCH_URL + `/${documentGuid}`)
                .then(resp => resp.json())
                .then(data => {

                    if(data.data) { 
                        dispatch(setApplicationCache({
                            documentGuid,
                            data
                        }))

                        return data
                    }

                    return null
                })
                .catch(error => {
                    console.error(error)
                    return null
                })
    } else { 
        return Promise.reject("documentId not provided")
    }
}

export default  supportingDocumentsSlice.reducer
